import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DependentAddition_Ops2 from "./dependentAddition_ops2";
import DependentAddition_ops1 from "./dependent_addition_ops1";
import { useEffect } from "react";
import nodeinstance from "../../../../nodeInstance";
import Finance_Dependent from "./dependent_addition_finance";
import ApplyInsurance from "./ApplyInsurance";

export default function Dependentaddition_OPS2() {
  const [index, setIndex] = useState(0);

  const changeIndex = (value) => {
    setIndex(value);
  };
  const token = localStorage.getItem("nodeToken");

  const [dependentDetails, SetDependentDetails] = useState();

  const [trigger, setTrigger] = useState(false);

  const [vendorIndex, setVendorIndex] = useState();
  console.log(".........", vendorIndex);
  const getData = async () => {
    const params =
      index === 0
        ? "OPS2"
        : index === 1
          ? "OPS1"
          : index === 2
            ? "FINANCE"
            : index === 3
              ? "APPLY INSURANCE"
              : "OPS2";
    try {
      const response = await nodeinstance.get(
        `insurance-dependent/getDependentByStatus/${params}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        SetDependentDetails(response?.data);
      }
    } catch (error) {
      console.log("error.......", error);
    }
  };
  //   useEffect(() => {
  //     getData();
  //   }, []);
  useEffect(() => {
    getData();
  }, [trigger, index]);

  return (
    <>
      <div className="mt-4 w-[95%] mx-auto">
        <div className="flex ">
          <Link to="/dashboard/dependent-addition">
            <button
              className={`p-3 m-2 h-10  uppercase text-xs mr-4 rounded-md ${index == 0 ? "bg-red text-white" : "bg-[#BFBFBF] text-black"}`}
              onClick={() => {
                changeIndex(0);
              }}
            >
              OPS 2
            </button>
          </Link>
          <Link to="/dashboard/dependent-addition/ops1">
            <button
              className={`p-3 m-2 h-10  uppercase text-xs mr-4 rounded-md ${index == 1 ? "bg-red text-white" : "bg-[#BFBFBF] text-black"}`}
              onClick={() => {
                changeIndex(1);
              }}
            >
              OPS 1
            </button>
          </Link>
          <button
            className={`p-3 m-2 h-10  uppercase text-xs mr-4 rounded-md ${index == 2 ? "bg-red text-white" : "bg-[#BFBFBF] text-black"}`}
            onClick={() => {
              changeIndex(2);
            }}
          >
            FINANCE
          </button>
          <button
            className={`p-3 m-2 h-10  uppercase text-xs mr-4 rounded-md ${index == 3 ? "bg-red text-white" : "bg-[#BFBFBF] text-black"}`}
            onClick={() => {
              changeIndex(3);
            }}
          >
            APPLY INSURANCE
          </button>
        </div>
        <div>
          {index === 0 ? (
            <DependentAddition_Ops2
              dependentDetails={dependentDetails}
              setTrigger={setTrigger}
              trigger={trigger}
              titles={[
                "S.NO",
                "APPROVED DATE",
                "REQUEST TYPE",
                "NO OF DEPENDENTS",
                "EMP NAME",
                "EMP ID",
                "GENDER",
                "NATIONALITY",
                "ACTUAL PROFESSION",
                "CLIENT NAME",
                "IQAMA NUMBER",
                "IQAMA EXPIRY DATE",
                "PROJECT NAME",
                "INSURANCE CLASS",
                "STATUS",
                "ACTION",
              ]}
              index={index}
            />
          ) : index === 1 ? (
            <DependentAddition_ops1
              dependentDetails={dependentDetails}
              setTrigger={setTrigger}
              trigger={trigger}
              setIndex={setIndex}
              titles={[
                "S.NO",
                "REQUEST TYPE",
                "NO OF DEPENDENTS",
                "EMP NAME",
                "EMP ID",
                "GENDER",
                "NATIONALITY",
                "ACTUAL PROFESSION",
                "CLIENT NAME",
                "IQAMA NUMBER",
                "IQAMA EXPIRY DATE",
                "PROJECT NAME",
                "INSURANCE CLASS",
                "ACTION",
              ]}
              index={index}
            />
          ) : index === 2 ? (
            <Finance_Dependent
              dependentDetails={dependentDetails}
              setTrigger={setTrigger}
              trigger={trigger}
              setIndex={setIndex}
              setVendorIndex={setVendorIndex}
              index={index}
            />
          ) : index === 3 ? (
            <ApplyInsurance index={index} />
          ) : (
            <DependentAddition_Ops2
              dependentDetails={dependentDetails}
              setTrigger={setTrigger}
              trigger={trigger}
              setIndex={setIndex}
              index={index}
            />
          )}
        </div>
      </div>
    </>
  );
}
